import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

import Customers from "../pages/Customers/Index";
import AdminChiefs from "../pages/Customers/AdminChiefs/index";
import EditCustomer from "../pages/Customers/Update";

const customerPages = {
  path: "/",
  component: DashboardLayout,
  name: "customerPages",
  title: "Clientes",
  icon: "business",
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/clientes",
      name: "Clientes",
      title: "Clientes",
      component: Customers,
      meta: {
        ifUserCan: {
          view: "Customer/customer",
        },
      },
    },
    {
      path: "/jefes_administrativos",
      name: "Jefes Administrativos",
      title: "Jefes Administrativos",
      component: AdminChiefs,
      meta: {
        ifUserCan: {
          view: "Customer/administrativeboss2highway",
        },
      },
    },
    {
      path: "/clientes/:id",
      name: "Editar Cliente",
      props: true,
      component: EditCustomer,
      meta: {
        ifUserCan: {
          change: "Customer/customer",
        },
      },
    },
  ],
};

export default customerPages;



// WEBPACK FOOTER //
// ./src/router/customerRoutes.js